<template>
    <div class="mini-calendar__collapse">
        <div class="mini-calendar__collapse-header" :class="{active: is_open}" @click="onclick">{{title}}<span class="icon-plus"></span></div>
        <div class="mini-calendar__collapse-content">
            <label v-for="(item) in categories" :key="item.id" class="cat-item">
                <span v-if="option == 'checkbox'">
                    <input type="checkbox" :value="item.id" :id="item.id" v-model="selectedbox" @change="checkbox()"/>
                </span>
                <span v-else>
                    <input type="radio" :id="'mini-calender' + title" :value="item.id" :checked="item.id == this.date_range.type" @change="checkradio"/>
                </span>
                {{item.name}}</label>
            <MiniCalenderDateFilter v-if="title == 'Date'" v-show="this.date_range.type == 'custom_range'"/>
        </div>
    </div>
</template>

<script>
import MiniCalenderDateFilter from "./mini-calendar-date-filter.vue"
import moment from 'moment'
import { getFilteredEvents } from './../../api'
import { mapActions, mapGetters } from 'vuex'
import { DATE_FORMAT } from '@/utils/config'
import { RouterPath } from '@/utils/mixin'

export default {
    name: 'MiniCalendarCollpase',
    mixins: [RouterPath],
    components: {
        MiniCalenderDateFilter
    },
    props: {
        title: String,
        categories: Array,
        option: {
            type: String,
            default: "checkbox"
        },
        opend: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            is_open: this.opend,
            selected: '',
            selectedbox: [],
        }
    },
    watch: {
      filter: function (newVal) {
        this.selectedbox = newVal
        const filtered = this.categories.filter((item) => newVal.indexOf(item.id) >= 0);
        if (filtered.length) {
            this.is_open = true;
        }
      }
    },
    computed: {
        ...mapGetters(['date_range', 'filter', 'categorylist'])
    },
    methods: {
        onclick() {
            this.is_open = !this.is_open
        },
        checkradio(e) {

            let selected = e.target.value;
            let start = "", end = "";

            if (selected == "today") {
                start = moment().format(DATE_FORMAT);
                end = moment().format(DATE_FORMAT);
            } else if (selected == "tomorrow") {
                start = moment().add(1,'days').format(DATE_FORMAT);
                end = moment().add(1,'days').format(DATE_FORMAT);
            } else if (selected == "week") {
                start = moment().startOf("week").format(DATE_FORMAT);
                end = moment().endOf('week').format(DATE_FORMAT);
            } else if (selected == "month") {
                start = moment().startOf("month").format(DATE_FORMAT);
                end = moment().endOf("month").format(DATE_FORMAT);
            } else if (selected == "custom_range") {
                this.setDateRange({
                    type: selected,
                    start: '',
                    end: ''
                });
                return;
            } else {
                start = moment().format(DATE_FORMAT)
            }

            this.setDateRange({
                type: selected,
                start: start,
                end: end
            });

            this.setLoading(true);

            getFilteredEvents(start, end).then((response) => {

                if (response) {

                    let data = response.data ? response.data : [];

                    this.setEventList({eventlist: data, total: response.query.total})
                }

                this.setLoading(false);
            }).catch(() => {
                this.setLoading(false);
            });
        },
        checkbox() {
            this.setLoading(true);

            getFilteredEvents(this.date_range.start, this.date_range.end, this.selectedbox).then((response) => {
                this.setSearch({search: ''});
                this.setFilter(this.selectedbox);
                this.pushurl(this.selectedbox);

                if (response) {

                    let data = response.data ? response.data : [];

                    this.setEventList({eventlist: data, total: response.query.total})
                }
                this.setLoading(false);
            }).catch(() => {
                this.setLoading(false);
            });

        },
        ...mapActions(['setDateRange', 'setEventList', 'setLoading', 'setFilter' ,'setSearch'])
    }
}
</script>

<style lang="scss">
    .mini-calendar__collapse {
        width: 100%;
        border-top: 2px solid $border-color2;
        border-bottom: 0;

        &:last-child {
            border-bottom: 2px solid $border-color2;
        }

        &-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            font-size: rem(22);
            line-height: 1.25;
            padding: rem(18) rem(0);
            color: $text-color1;
            margin: 0;
            cursor: pointer;

            .icon-plus {
                position: relative;
                display: block;
                width: 10px;
                height: 10px;

                &:before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 100%;
                    height: 2px;
                    margin-top: -1px;
                    background-color: $text-color;
                }

                &:after {
                    position: absolute;
                    left: 50%;
                    top: 0;
                    content: "";
                    height: 100%;
                    width: 2px;
                    margin-left: -1px;
                    background-color: $text-color;
                    opacity: 1;
                }
            }

            &.active + div {
                display: block!important;
            }

            &.active {
                .icon-plus {
                    &:after {
                        opacity: 0;
                    }

                    &:before {
                        background-color: $alert-color;
                    }
                }
            }
        }

        &-content {
            display: none;
            padding-bottom: rem(30);

            > label {
                padding: rem(4) 0;
                display: block;
            }

            input[type=checkbox],
            input[type=radio] {
                display: inline-block;
                vertical-align: middle;
                height: rem(16);
                width: rem(16);
                border: 0;
                margin-bottom: rem(4);
                padding: 0;
                font-family: 'Open Sans';
                font-size: rem(16);
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                -webkit-box-shadow: inset 0 0 0 1px $border-color;
                box-shadow: inset 0 0 0 1px $border-color;
                outline: 0;
                -webkit-transition: background .2s,-webkit-box-shadow .2s;
                transition: background .2s,box-shadow .2s;
                margin-right: rem(10);
                border-radius: 0;

                &:checked {
                    background: $alert-color;
                }
            }

            input[type=radio] {
                border-radius: 100%;
            }

            .cat-item {
                position: relative;
                padding-left: rem(30);

                > span {
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
</style>